export const fmt = (n, digits = 2) => n == null ? '—' : new Intl.NumberFormat('en-GB', { maximumFractionDigits: digits, minimumFractionDigits: digits }).format(n);
export const eur = n => n == null ? '—' : `€${fmt(n)}`;
export const pct = n => n == null ? '—' : `${fmt(n * 100, 1)}%`;
export const statusLabel = {
  settled: 'Settled', pending: 'Pending settlement', idle: 'Within margin', no_market: 'No market at cutoff',
  missing_forecast: 'No forecast at cutoff', incomplete_forecast: 'Incomplete forecast', invalid_quote: 'Crossed quote',
  missing_depth: 'MBO depth unavailable', unfilled: 'No fill',
};

export function parisDate(offset = 0) {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
  const value = type => parts.find(p => p.type === type).value;
  const day = new Date(`${value('year')}-${value('month')}-${value('day')}T12:00:00Z`);
  day.setUTCDate(day.getUTCDate() + offset);
  return day.toISOString().slice(0, 10);
}

export function downloadCsv(name, rows) {
  if (!rows.length) return;
  const keys = Object.keys(rows[0]);
  const escape = value => `"${String(value ?? '').replace(/"/g, '""')}"`;
  const csv = [keys.join(','), ...rows.map(row => keys.map(k => escape(row[k])).join(','))].join('\r\n');
  const url = URL.createObjectURL(new Blob(['\uFEFF', csv], { type: 'text/csv;charset=utf-8' }));
  const anchor = document.createElement('a');
  anchor.href = url; anchor.download = name; anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
